import React from 'react';
import { Helmet } from 'react-helmet';

const SEO = ({ 
  title, 
  description, 
  image = '/uploads/hospital-journey/IMG_1008.jpeg',
  url,
  type = 'website',
  children 
}) => {
  const siteUrl = 'https://butdidyoudie.life';
  const fullUrl = url ? `${siteUrl}${url}` : siteUrl;
  const fullTitle = title ? `${title} | Maggie's Miracle` : "Maggie's Miracle | But Did You Die?";
  const fullImage = image.startsWith('http') ? image : `${siteUrl}${image}`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      
      {/* Open Graph Tags */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Maggie's Miracle" />
      
      {/* Twitter Card Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImage} />
      
      {/* Additional Meta Tags */}
      <meta name="robots" content="index, follow" />
      <meta name="author" content="Scott Soward" />
      <meta name="keywords" content="miracle, faith, cardiac arrest, survival, family, prayer, emergency response, CPR, medical miracle, testimony, grace, recovery" />
      
      {/* Canonical URL */}
      <link rel="canonical" href={fullUrl} />
      
      {/* Schema.org JSON-LD */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": type === 'article' ? 'Article' : 'WebSite',
          "name": title || "Maggie's Miracle",
          "description": description,
          "url": fullUrl,
          "image": fullImage,
          "author": {
            "@type": "Person",
            "name": "Scott Soward"
          },
          "publisher": {
            "@type": "Organization",
            "name": "Maggie's Miracle",
            "logo": {
              "@type": "ImageObject",
              "url": `${siteUrl}/logo192.png`
            }
          },
          ...(type === 'article' && {
            "datePublished": "2024-11-28",
            "dateModified": "2024-12-05",
            "mainEntityOfPage": {
              "@type": "WebPage",
              "@id": fullUrl
            }
          })
        })}
      </script>
      
      {children}
    </Helmet>
  );
};

export default SEO;
